import { Pipe, PipeTransform } from '@angular/core';

import {
  VipDiscountDto,
  OriginalSortimentEntryResponse,
} from '@app/api/models';

@Pipe({
  name: 'originalPrice',
})
export class OriginalPricePipe implements PipeTransform {
  transform(
    element: OriginalSortimentEntryResponse & VipDiscountDto,
    segment: 'MANUFACTURER_OR_IMPORTER' | 'WHOLESALE' | 'RETAIL' | 'CONSUMER'
  ): number | undefined {
    return element.prices?.find((el) => el.segment === segment)?.value;
  }
}
